/* ===== Bella custom scripts ===== */

/* Any link whose URL ends in #top smoothly scrolls the page back to the top. */
document.addEventListener('click', function (event) {
  var trigger = event.target.closest('a[href="#top"], a[href$="#top"], [data-scroll-top]');
  if (!trigger) return;

  event.preventDefault();
  window.scrollTo({ top: 0, behavior: 'smooth' });
});